import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import QueryDropdown from '@/components/QueryDropdown.vue';
import { useArticlesStore } from '@/stores/articles';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticlesSort',
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const articlesStore = useArticlesStore();
        const sortOptions = [
            {
                key: 'outerDiameter',
                label: $t('Outer diameter'),
            },
            // {
            //   key: 'innerDiameter',
            //   label: $t('Inner diameter'),
            // },
            {
                key: 'wallThickness',
                label: $t('Wall thickness'),
            },
            // {
            //   key: 'relevance',
            //   label: $t('Relevance'),
            // },
        ];
        const __returned__ = { $t, articlesStore, sortOptions, QueryDropdown };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
